// extracted by mini-css-extract-plugin
export default {"button":"button_button__5m3ez","loader":"button_loader__5apVq","spin":"button_spin__n1dEW"};